module.exports = require("npm:z-schema@3.17.0/src/ZSchema.js");